import { useState } from "react";

const MESSAGES = {
  401: "Wrong password.",
  429: "Too many failed attempts. Login is locked for 15 minutes.",
};

export const AdminLogin = ({ http, onSuccess }) => {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await http.post("/admin/login", { password });
      onSuccess();
    } catch (err) {
      setError(MESSAGES[err.response?.status] || "Login failed.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="adm">
      <form className="adm-login" onSubmit={submit} data-testid="admin-login-form">
        <h1>Astralsand admin</h1>
        <label htmlFor="adm-pass">Password</label>
        <input id="adm-pass" type="password" autoComplete="current-password" value={password}
          onChange={(e) => setPassword(e.target.value)} data-testid="admin-password-input" />
        <button type="submit" disabled={busy || !password} data-testid="admin-login-button">Sign in</button>
        <p className="adm-error" role="alert" data-testid="admin-login-error">{error}</p>
      </form>
    </div>
  );
};
